var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Gender ")]),(_vm.status)?_c('Doughnut',{attrs:{"data":_vm.chartData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }